import { functions } from '@/firebase';
import { httpsCallable } from 'firebase/functions';
import { BuyTicketRequest, Ticket } from '@packages/types';

export const buyTicketFn = httpsCallable<BuyTicketRequest, { ticket: Ticket }>(
  functions,
  'buyTicket',
);
